import { apiClient } from "@base/api/client";
import type { PaginationResponse } from "@base/model/types";
import { useSuspenseInfiniteQuery } from "@tanstack/react-query";
import type { FileHistoryEvent } from "./schema";

type FileHistoryPageResponse = PaginationResponse<FileHistoryEvent[]>;

const FILE_HISTORY_PAGE_SIZE = 20;

async function fetchFileHistory(projectId: string, logId: string, page: number): Promise<FileHistoryPageResponse> {
  const response = await apiClient.get<FileHistoryPageResponse>(
    `/project-management/api/projects/${projectId}/daily-logs/${logId}/events`,
    { params: { page, page_size: FILE_HISTORY_PAGE_SIZE } },
  );
  return response.data;
}

export function useInfiniteFileHistoryQuery(projectId: string, logId: string) {
  return useSuspenseInfiniteQuery({
    queryKey: ["file-history", projectId, logId] as const,
    queryFn: ({ pageParam }) => fetchFileHistory(projectId, logId, pageParam),
    initialPageParam: 1,
    getNextPageParam: (lastPage) => {
      if (lastPage.current_page < lastPage.total_pages) {
        return lastPage.current_page + 1;
      }
      return undefined;
    },
  });
}
